export default __webpack_public_path__ + "ef24e59b7cba504ff1e4b5bbb4571679.svg";